<img class="circle-container canton-logo" src="https://lutzangeles.blob.core.windows.net/app/{{ subdomain }}/{{ subdomain }}.png" />
